export const CookieConstant = {
    nameCookie: "CookiePortalIpan",
    advertising: "advertising",
    analytics: "analytics",
    essential: "essential",
    performance: "performance",
    thirdparties: "thirdparties"
}